import React from "react"

import { Card } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import TicketHeaderSkeleton from "../TicketHeaderSkeleton"

const useStyles = makeStyles((theme) => ({
  "@global": {
    ".MuiPaper-outlined": {
      border: "none",
      borderTop: "1px " + theme.palette.neutral200 + " solid",
      borderBottom: "1px " + theme.palette.neutral200 + " solid",
      borderRight: "1px " + theme.palette.neutral200 + " solid",
    },
  },
  ticketHeader: {
    display: "flex",
    backgroundColor: theme.palette.background100,
    flex: "none",
    borderBottom: "1px " + theme.palette.neutral200 + " solid",
    [theme.breakpoints.down("xs")]: {
      alignItems: "center",
      minHeight: 64,
      width: "100%",
      overflow: "hidden",
    },
  },
}))

const TicketHeader = ({ loading, children }) => {
  const classes = useStyles()

  return (
    <>
      {loading ? (
        <TicketHeaderSkeleton />
      ) : (
        <Card elevation={0} square className={classes.ticketHeader}>
          {children}
        </Card>
      )}
    </>
  )
}

export default TicketHeader
